module.exports = __webpack_public_path__ + "static/leadrx-user-journey-7b0ce556f2e6d3543318a1b7b8e4811c.jpg";